import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  policies: [],
  selectedPolicy: null,
  pagination: {},
};

const attendancePolicySlice = createSlice({
  name: "attendancePolicy",
  initialState,
  reducers: {
    // Get all policies
    getPoliciesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPoliciesSuccess: (state, action) => {
      state.loading = false;
      state.policies = action.payload.data || [];
      state.pagination = action.payload.pagination || {};
      state.error = null;
    },
    getPoliciesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Get single policy
    getPolicyByIdStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPolicyByIdSuccess: (state, action) => {
      state.loading = false;
      state.selectedPolicy = action.payload;
      state.error = null;
    },
    getPolicyByIdFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create policy
    createPolicyStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createPolicySuccess: (state, action) => {
      state.loading = false;
      state.policies.unshift(action.payload);
      state.error = null;
    },
    createPolicyFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update policy
    updatePolicyStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updatePolicySuccess: (state, action) => {
      state.loading = false;
      const index = state.policies.findIndex((p) => p.id === action.payload.id);
      if (index !== -1) {
        state.policies[index] = action.payload;
      }
      state.selectedPolicy = action.payload;
      state.error = null;
    },
    updatePolicyFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete policy
    deletePolicyStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deletePolicySuccess: (state, action) => {
      state.loading = false;
      state.policies = state.policies.filter((p) => p.id !== action.payload);
      state.error = null;
    },
    deletePolicyFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Clear error
    clearPolicyError: (state) => {
      state.error = null;
    },

    // Clear selected policy
    clearSelectedPolicy: (state) => {
      state.selectedPolicy = null;
    },
  },
});

export const {
  getPoliciesStart,
  getPoliciesSuccess,
  getPoliciesFailure,
  getPolicyByIdStart,
  getPolicyByIdSuccess,
  getPolicyByIdFailure,
  createPolicyStart,
  createPolicySuccess,
  createPolicyFailure,
  updatePolicyStart,
  updatePolicySuccess,
  updatePolicyFailure,
  deletePolicyStart,
  deletePolicySuccess,
  deletePolicyFailure,
  clearPolicyError,
  clearSelectedPolicy,
} = attendancePolicySlice.actions;

export default attendancePolicySlice.reducer;
